import uuidFromString from 'uuid-by-string';

export default uuidFromString;
